/* eslint-disable no-unused-vars */
import SiteTemplate from '@/templates/site-interno/SiteTemplate'
import Login from '@/pages/auth/Login'
import LoginExterno from '@/pages/auth/LoginExterno'
import LoginRedirect from '@/pages/auth/LoginRedirect'
import RecuperarSenha from '@/pages/auth/RecuperarSenha'
import AlterarSenha from '@/pages/auth/AlterarSenha'
import HomeExterna from '@/pages/site/externa/Home'
import HomeInterna from '@/pages/site/interna/Home'
import Documentos from '@/pages/site/interna/Documentos'

import Usuario from '@/pages/site/interna/administrador/usuarios/Usuarios'
import UsuarioVisualizar from '@/pages/site/interna/administrador/usuarios/UsuarioVisualizar'
import UsuarioEditar from '@/pages/site/interna/administrador/usuarios/UsuarioEditar'
import UsuarioCadastrar from '@/pages/site/interna/administrador/usuarios/UsuarioCadastrar'
import UsuarioVincular from '@/pages/site/interna/administrador/usuarios/UsuarioVincular'
import MeuPerfilAdministrador from '@/pages/site/interna/perfil/MeuPerfilAdministrador'
import MeuPerfilParticipante from '@/pages/site/interna/perfil/MeuPerfilParticipante'

import MinhaFicha from '@/pages/site/interna/participante/VisualizarMinhaFicha'

import SucessoInscricao from '@/pages/auth/SucessoInscricao'
import InscricaoIndisponivel from '@/pages/auth/InscricaoIndisponivel'
import Inscricao from '@/pages/auth/Inscricao'
import InscricaoPreview from '@/pages/auth/InscricaoPreview'

import Participante from '@/pages/site/interna/participante/Participante'
import ParticipanteDelegado from '@/pages/site/interna/participante/ParticipanteDelegado'

import ParticipanteCadastrar from '@/pages/site/interna/participante/ParticipanteCadastrar'
import ParticipanteEditar from '@/pages/site/interna/participante/ParticipanteEditar'
import ParticipanteVisualizar from '@/pages/site/interna/participante/ParticipanteVisualizar'
import Delegado from '@/pages/site/interna/participante/Delegado'
import Credenciado from '@/pages/site/interna/participante/Credenciado'

import Formulario from '@/pages/site/interna/formularios/Formularios'
import FormularioCadastrar from '@/pages/site/interna/formularios/FormularioCadastrar'
import FormularioDuplicar from '@/pages/site/interna/formularios/FormularioDuplicar'

import Regimento from '@/pages/site/interna/regimento/Regimento'
import RegimentoCadastrar from '@/pages/site/interna/regimento/RegimentoCadastrar'
import RegimentoEditar from '@/pages/site/interna/regimento/RegimentoEditar'
import RegimentoVisualizar from '@/pages/site/interna/regimento/RegimentoVisualizar'
import RegimentoEntrada from '@/pages/site/interna/regimento/RegimentoEntrada'
import RegimentoConsulta from '@/pages/site/interna/regimento/RegimentoConsulta'

import Sala from '@/pages/site/interna/salas/Sala'
import SalaCadastrar from '@/pages/site/interna/salas/SalaCadastrar'
import SalaEditar from '@/pages/site/interna/salas/SalaEditar'
import SalaVisualizar from '@/pages/site/interna/salas/SalaVisualizar'
import SalaConsulta from '@/pages/site/interna/salas/SalaConsulta'

import Arquivos from '@/pages/site/interna/arquivos/Arquivos'
import ArquivoCadastrar from '@/pages/site/interna/arquivos/ArquivosCadastrar'
import ArquivoEditar from '@/pages/site/interna/arquivos/ArquivosEditar'
import ArquivoVisualizar from '@/pages/site/interna/arquivos/ArquivosVisualizar'

import Areas from '@/pages/site/interna/area/Areas'
import AreaCadastrar from '@/pages/site/interna/area/AreaCadastrar'
import AreaEditar from '@/pages/site/interna/area/AreaEditar'
import AreaVisualizar from '@/pages/site/interna/area/AreaVisualizar'

import Certificados from '@/pages/site/interna/certificados/Certificados'
import CertificadoParticipante from '@/pages/site/interna/certificados/CertificadoParticipante'
import CertificadoCadastrar from '@/pages/site/interna/certificados/CertificadoCadastrar'
import CertificadoEditar from '@/pages/site/interna/certificados/CertificadoEditar'
import CertificadoVisualizar from '@/pages/site/interna/certificados/CertificadoVisualizar'

import Forum from '@/pages/site/interna/caderno/Forum'

import Proposta from '@/pages/site/interna/caderno/Proposta'
import PropostaCadastrar from '@/pages/site/interna/caderno/PropostaCadastrar'
import PropostaEditar from '@/pages/site/interna/caderno/PropostaEditar'
import PropostaVisualizar from '@/pages/site/interna/caderno/PropostaVisualizar'
import PropostaEntrada from '@/pages/site/interna/caderno/PropostaEntrada'
import PropostaConsulta from '@/pages/site/interna/caderno/PropostaConsulta'

import PropostaSugestaoLista from '@/pages/site/interna/proporPropostas/PropostaSugestaoLista'
import PropostaSugestaoCadastro from '@/pages/site/interna/proporPropostas/PropostaSugestaoCadastrar'
import PropostaSugestaoEditar from '@/pages/site/interna/proporPropostas/PropostaSugestaoEditar'
import PropostaSugestaoVisualizar from '@/pages/site/interna/proporPropostas/PropostaSugestaoVisualizar'
import PropostaSugestaoAlterarSituacao from '@/pages/site/interna/proporPropostas/PropostaSugestaoAlterarSituacao'

import PropostaSegunda from '@/pages/site/interna/cadernoSegundaEtapa/PropostaSegunda'
import PropostaSegundaCadastrar from '@/pages/site/interna/cadernoSegundaEtapa/PropostaSegundaCadastrar'
import PropostaSegundaEditar from '@/pages/site/interna/cadernoSegundaEtapa/PropostaSegundaEditar'
import PropostaSegundaVisualizar from '@/pages/site/interna/cadernoSegundaEtapa/PropostaSegundaVisualizar'
import PropostaSegundaEntrada from '@/pages/site/interna/cadernoSegundaEtapa/PropostaSegundaEntrada'
import PropostaSegundaConsulta from '@/pages/site/interna/cadernoSegundaEtapa/PropostaSegundaConsulta'

import PropostaTerceira from '@/pages/site/interna/cadernoTerceiraEtapa/PropostaTerceira'
import PropostaTerceiraCadastrar from '@/pages/site/interna/cadernoTerceiraEtapa/PropostaTerceiraCadastrar'
import PropostaTerceiraEditar from '@/pages/site/interna/cadernoTerceiraEtapa/PropostaTerceiraEditar'
import PropostaTerceiraVisualizar from '@/pages/site/interna/cadernoTerceiraEtapa/PropostaTerceiraVisualizar'
import PropostaTerceiraEntrada from '@/pages/site/interna/cadernoTerceiraEtapa/PropostaTerceiraEntrada'
import PropostaTerceiraConsulta from '@/pages/site/interna/cadernoTerceiraEtapa/PropostaTerceiraConsulta'

import Mocao from '@/pages/site/interna/mocao/Mocao'
import MocaoCadastrar from '@/pages/site/interna/mocao/MocaoCadastrar'
import MocaoEditar from '@/pages/site/interna/mocao/MocaoEditar'
import MocaoConsulta from '@/pages/site/interna/mocao/MocaoConsulta'

import SalaChat from '@/pages/site/interna/salaChat/SalaChat'
import SalaChatCadastrar from '@/pages/site/interna/salaChat/SalaChatCadastrar'
import SalaChatEditar from '@/pages/site/interna/salaChat/SalaChatEditar'
import SalaChatConsulta from '@/pages/site/interna/salaChat/SalaChatConsulta'

import ConferenciaConsultar from '@/pages/site/interna/conferencia/Consultar'
import ConferenciaCadastrar from '@/pages/site/interna/conferencia/Cadastrar'
import ConferenciaVisualizar from '@/pages/site/interna/conferencia/Visualizar'

import Administrativa from '@/pages/site/interna/Administrativa'
import ModeloAdministrativo from '@/templates/site-interno/ModeloAdministrativo'
import Autenticada from '@/pages/site/interna/Autenticada'

import ConfigurarConferencia1 from '@/pages/site/interna/conferencia/Passo1'
import ConfigurarConferencia2 from '@/pages/site/interna/conferencia/Passo2'
import ConfigurarConferencia3 from '@/pages/site/interna/conferencia/Passo3'
import ConfigurarConferencia4 from '@/pages/site/interna/conferencia/Passo4'
import GerenciarConferencia from '@/pages/site/interna/conferencia/Gerenciar'
import RelacionarConferencia from '@/pages/site/interna/conferencia/Relacionar'

/** TUTORIAIS */
import TutorialList from '@/pages/site/interna/tutoriais/Tutoriais'
import TutorialCadastrar from '@/pages/site/interna/tutoriais/TutorialCadastrar'
import TutorialEditar from '@/pages/site/interna/tutoriais/TutorialEditar'
import TutorialVisualizar from '@/pages/site/interna/tutoriais/TutorialVisualizar'
import Tutorial from '@/pages/site/interna/tutoriais/Tutorial'
import TutorialAtivo from '@/pages/site/interna/tutoriais/TutorialAtivo'

import Links from '@/pages/site/interna/links/Link'
import LinkForm from '@/pages/site/interna/links/LinkForm'

import AdministradorForm from '@/pages/site/interna/administrador/usuariosAdministrador/AdministradorForm'
import Administrador from '@/pages/site/interna/administrador/usuariosAdministrador/Administrador'

import PropostaDelegacao from '@/pages/site/interna/propostaDelegacao/PropostaDelegacao'
import PropostaDelegacaoForm from '@/pages/site/interna/propostaDelegacao/PropostaDelegacaoForm'

import Delegacao from '@/pages/site/interna/delegacao/Delegacao'

const routes = [
  {
    path: '/',
    redirect: '/',
    name: 'Conferência',
    component: SiteTemplate,
    children: [
      {
        path: '/',
        component: HomeInterna
      },
      {
        path: '/documentos',
        component: Documentos
      },
      {
        path: '/perfil-administrador',
        name: 'Meu Perfil',
        component: MeuPerfilAdministrador
      },
      {
        path: '/perfil-participante',
        name: 'Meu Perfil',
        component: MeuPerfilParticipante
      },
      {
        path: '/ficha',
        name: 'Minha Ficha',
        component: MinhaFicha
      },

      // Participantes
      {
        path: '/participante',
        name: 'Listagem de Participantes',
        component: Participante
      },
      {
        path: '/participante/cadastro',
        name: 'Cadastro de Participante',
        component: ParticipanteCadastrar
      },
      {
        path: '/participante/editar/:id',
        name: 'Edição de Participante',
        component: ParticipanteEditar
      },
      {
        path: '/participante/visualizar/:id',
        name: 'Visualização de Participante',
        component: ParticipanteVisualizar
      },
      {
        path: '/participante/delegados',
        name: 'Listagem de Delegados',
        component: Delegado
      },
      {
        path: '/participante/credenciados',
        name: 'Listagem de Credenciados',
        component: Credenciado
      },
      {
        path: '/inscricoes/delegado',
        name: 'Listar inscrições',
        component: ParticipanteDelegado
      },

      // Formulários
      {
        path: '/formularios',
        name: 'Formulários',
        component: Formulario,
      },
      {
        path: '/formularios',
        name: 'Formulários',
        component: FormularioCadastrar,
        children: [         
          {
            path: '/formulario/cadastrar',
            name: 'Cadastrar Formulário',             
          },  
        ] 
      },
      {
        path: '/formularios',
        name: 'Formulários',
        component: FormularioDuplicar,
        children: [         
          {
            path: '/formulario/:id/duplicar',
            name: 'Duplicar Formulário',             
          },  
        ] 
      },

      {
        path: '/sala',
        name: 'Listar Salas de Transmissão',
        component: Sala
      },
      {
        path: '/sala/cadastrar',
        name: 'Cadastrar Salas de Transmissão',
        component: SalaCadastrar
      },
      {
        path: '/sala/editar/:id',
        name: 'Editar Salas de Transmissão',
        component: SalaEditar
      },
      {
        path: '/sala/visualizar/:id',
        name: 'Visualizar Salas de Transmissão',
        component: SalaVisualizar
      },
      {
        path: '/sala/consulta',
        name: 'Visualizar Salas de Transmissão',
        component: SalaConsulta
      },
      {
        path: '/sala/consulta/:id',
        name: 'Visualizar Salas de Transmissão',
        component: SalaConsulta
      },

      // Fórum
      {
        path: '/forum',
        name: 'Forum',
        component: Forum
      },

      // Propostas - Perfil Delegado 
      {
        path: '/proposta/lista-propostas',
        name: 'Propostas',
        component: PropostaSugestaoLista
      },

      {
        path: '/proposta/sugestao/cadastrar',
        name: 'Cadastrar Proposta',
        component: PropostaSugestaoCadastro
      },

      {
        path: '/proposta/sugestao/visualizar/:id',
        name: 'Visualizar Proposta',
        component: PropostaSugestaoVisualizar
      },

      {
        path: '/proposta/sugestao/editar/:id',
        name: 'Editar Proposta',
        component: PropostaSugestaoEditar
      },

      {
        path: '/proposta/sugestao/situacao/:id',
        name: 'Alterar Situaçao Proposta',
        component: PropostaSugestaoAlterarSituacao
      },
      
      // Propostas - Administrador
      {
        path: '/proposta',
        name: 'Caderno de Propostas',
        component: Proposta
      },
      {
        path: '/proposta/cadastrar',
        name: 'Cadastrar Proposta',
        component: PropostaCadastrar
      },
      {
        path: '/proposta/editar/:id',
        name: 'Editar Proposta',
        component: PropostaEditar
      },
      {
        path: '/proposta/visualizar/:id',
        name: 'Visualizar Proposta',
        component: PropostaVisualizar
      },
      {
        path: '/proposta-entrada',
        name: 'Visualizar Proposta',
        component: PropostaEntrada
      },
      {
        path: '/proposta/contribuir/:eixo',
        name: 'Visualizar Proposta',
        component: PropostaConsulta
      },
      {
        path: '/proposta/:id',
        name: 'Visualização Proposta',
        component: PropostaConsulta
      },

      // Propostas - Segunda etapa
      {
        path: '/propostasegunda',
        name: 'Caderno de Propostas - Segunda Etapa',
        component: PropostaSegunda
      },
      {
        path: '/propostasegunda/cadastrar',
        name: 'Cadastrar Proposta - Segunda Etapa',
        component: PropostaSegundaCadastrar
      },
      {
        path: '/propostasegunda/editar/:id',
        name: 'Editar Proposta - Segunda Etapa',
        component: PropostaSegundaEditar
      },
      {
        path: '/propostasegunda/visualizar/:id',
        name: 'Visualizar Proposta - Segunda Etapa',
        component: PropostaSegundaVisualizar
      },
      {
        path: '/propostasegunda-entrada',
        name: 'Visualizar Proposta - Segunda Etapa',
        component: PropostaSegundaEntrada
      },
      {
        path: '/propostasegunda/contribuir/:eixo',
        name: 'Visualizar Proposta - Segunda Etapa',
        component: PropostaSegundaConsulta
      },
      // Propostas - Terceira etapa
      {
        path: '/propostaterceira',
        name: 'Caderno de Propostas - Terceira Etapa',
        component: PropostaTerceira
      },
      {
        path: '/propostaterceira/cadastrar',
        name: 'Cadastrar Proposta - Terceira Etapa',
        component: PropostaTerceiraCadastrar
      },
      {
        path: '/propostaterceira/editar/:id',
        name: 'Editar Proposta - Terceira Etapa',
        component: PropostaTerceiraEditar
      },
      {
        path: '/propostaterceira/visualizar/:id',
        name: 'Visualizar Proposta - Terceira Etapa',
        component: PropostaTerceiraVisualizar
      },
      {
        path: '/propostaterceira-entrada',
        name: 'Visualizar Proposta - Terceira Etapa',
        component: PropostaTerceiraEntrada
      },
      {
        path: '/propostaterceira/contribuir/:eixo',
        name: 'Visualizar Proposta - Terceira Etapa',
        component: PropostaTerceiraConsulta
      },

      // Moções
      {
        path: '/mocao',
        name: 'Moções',
        component: Mocao
      },
      {
        path: '/mocao/cadastrar',
        name: 'Cadastrar Moção',
        component: MocaoCadastrar
      },
      {
        path: '/mocao/editar/:id',
        name: 'Editar Moção',
        component: MocaoEditar
      },
      {
        path: '/mocao/visualizar/:id',
        name: 'Visualizar Moção',
        component: MocaoConsulta
      },
      // Salas de chat
      {
        path: '/salachat',
        name: 'Salas de Chat',
        component: SalaChat
      },
      {
        path: '/salachat/cadastrar',
        name: 'Cadastrar Salas de Chat',
        component: SalaChatCadastrar
      },
      {
        path: '/salachat/editar/:id',
        name: 'Editar Salas de Chat',
        component: SalaChatEditar
      },
      {
        path: '/salachat/visualizar/:id',
        name: 'Visualizar Salas de Chat',
        component: SalaChatConsulta
      },
      // Configurar conferência
      {
        path: '/conferencia',
        component: HomeInterna
      },
      {
        path: '/configurarConferencia/passo1/:acao',
        name: 'Configurar Conferência',
        component: ConfigurarConferencia1
      },
      {
        path: '/configurarConferencia/passo2/:acao',
        name: 'Configurar Conferência',
        component: ConfigurarConferencia2
      },
      {
        path: '/configurarConferencia/passo3/:acao',
        name: 'Configurar Conferência',
        component: ConfigurarConferencia3
      },
      {
        path: '/configurarConferencia/passo4/:acao',
        name: 'Configurar Conferência',
        component: ConfigurarConferencia4
      },
      {
        path: '/configurarConferencia/gerenciar',
        name: 'Gerenciar Configuração da Conferência',
        component: GerenciarConferencia
      },
      {
        path: '/configurarConferencia/relacionar',
        name: 'Relacionar Conferências',
        component: RelacionarConferencia
      },
      //Arquivos
      {
        path: '/arquivos',
        name: 'Listar Documentos',
        component: Arquivos
      },
      {
        path: '/arquivo/cadastrar',
        name: 'Cadastrar Documentos',
        component: ArquivoCadastrar
      },
      {
        path: '/arquivo/editar/:id',
        name: 'Editar Documentos',
        component: ArquivoEditar
      },
      {
        path: '/arquivo/visualizar/:id',
        name: 'Visualizar Documentos',
        component: ArquivoVisualizar
      },
      //Certificados
      {
        path: '/certificados',
        name: 'Listar Certificados',
        component: Certificados
      },
      {
        path: '/certificados/participante',
        name: 'Emitir Certificado',
        component: CertificadoParticipante
      },
      {
        path: '/certificados/cadastrar',
        name: 'Cadastrar Certificado',
        component: CertificadoCadastrar
      },
      {
        path: '/certificados/editar/:id',
        name: 'Editar Certificado',
        component: CertificadoEditar
      },
      {
        path: '/certificados/visualizar/:id',
        name: 'Visualizar Certificado',
        component: CertificadoVisualizar
      },
      {
        path: '/tutorial/cadastrar',
        component: TutorialCadastrar
      },
      {
        path: '/tutorial/:id/editar',
        component: TutorialEditar
      },
      {
        path: '/tutorial/:id/visualizar',
        component: TutorialVisualizar
      },
      {
        path: '/tutoriais',
        component: TutorialList
      },
      {
        path: '/tutorial/:id',
        component: Tutorial
      },
      {
        path: '/tutorial',
        component: TutorialAtivo
      },
      //Links
      {
        path: '/links',
        name: 'Gerenciar Links',
        component: Links
      },
      {
        path: '/link/cadastrar',
        name: 'Cadastrar Link',
        component: LinkForm
      },
      {
        path: '/link/:id/editar',
        name: 'Editar Link',
        component: LinkForm
      },
      {
        path: '/link/:id/visualizar',
        name: 'Visualizar Link',
        component: LinkForm
      },

      //Usuario Administrador
      {
        path: '/administrador/cadastrar',
        name: 'Cadastrar Administrador',
        component: AdministradorForm
      },      
      {
        path: '/administradores',
        name: 'Gerenciar Administradores',
        component: Administrador
      },
      {
        path: '/administrador/:id/editar',
        name: 'Editar Administrador',
        component: AdministradorForm
      },
      {
        path: '/administrador/:id/visualizar',
        name: 'Visualizar Administrador',
        component: AdministradorForm
      },

      //Propostas da Delegação
      {
        path: '/propostas/delegacao',
        name: 'Propostas da Delegação',
        component: PropostaDelegacao
      },
      {
        path: '/propostas/delegacao/:id/visualizar',
        name: 'Visualizar e Incluir propostas',
        component: PropostaDelegacaoForm
      },

      // Listar Delegação
      {
        path: '/delegacao',
        name: 'Delegação',
        component: Delegacao
      },
    ]
  },
  {
    path: '/administrativa',
    redirect: '/administrativa',
    name: 'Área Administrativa',
    component: ModeloAdministrativo,
    children: [
      {
        path: '/administrativa',
        component: Administrativa
      },
      {
        path: '/usuarios',
        name: 'Usuários',
        component: Usuario
      },
      {
        path: '/usuario/:id/visualizar',
        name: 'Visualizar Usuário',
        component: UsuarioVisualizar
      },
      {
        path: '/usuario/:id/editar',
        name: 'Edição do Usuário',
        component: UsuarioEditar
      },
      {
        path: '/usuario/cadastrar',
        name: 'Cadastrar do Usuário',
        component: UsuarioCadastrar
      },
      {
        path: '/usuario/vincular/:id',
        name: 'Vincular Usuário',
        component: UsuarioVincular
      },
      // Conferências
      {
        path: '/conferencias',
        name: 'Conferências',
        component: ConferenciaConsultar
      },
      {
        path: '/conferencias/cadastrar/:idConferencia',
        name: 'Cadastro de Conferências',
        component: ConferenciaCadastrar
      },
      {
        path: '/conferencias/editar/:idConferencia',
        name: 'Editar Conferências',
        component: ConferenciaCadastrar
      },
      {
        path: '/conferencias/visualizar/:idConferencia',
        name: 'Visualização de Conferências',
        component: ConferenciaVisualizar
      },
      //Areas
      {
        path: '/areas',
        name: 'Listar Áreas',
        component: Areas
      },
      {
        path: '/area/cadastrar',
        name: 'Cadastrar Área',
        component: AreaCadastrar
      },
      {
        path: '/area/editar/:id',
        name: 'Editar Área',
        component: AreaEditar
      },
      {
        path: '/area/visualizar/:id',
        name: 'Visualizar Área',
        component: AreaVisualizar
      },
    ]
  },
  {
    path: '/login',
    component: LoginExterno
  },
  {
    path: '/external-redirect',
    name: 'Área Externa',
    component: LoginRedirect
  },
  {
    path: '/inscricao',
    component: Inscricao
  },
  {
    path: '/inscricao/visualizar/:token',
    name: 'Visualização da Inscrição',
    component: InscricaoPreview
  },
  {
    path: '/sucesso-inscricao',
    component: SucessoInscricao
  },
  {
    path: '/inscricao-indisponivel',
    component: InscricaoIndisponivel
  },
  {
    path: '/recuperar-senha',
    component: RecuperarSenha
  },
  {
    path: '/alterar-senha/:token',
    component: AlterarSenha
  },
  {
    path: '/externa',
    name: 'Área Externa',
    component: HomeExterna
  },
  {
    path: '/logout',
    name: 'Logout',
    component: HomeExterna
  },
  {
    path: '/autenticada',
    component: Autenticada
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js